import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';

interface FadeInViewProps extends HTMLMotionProps<"div"> {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
}

export const FadeInView: React.FC<FadeInViewProps> = ({ 
  children, 
  delay = 0, 
  duration = 0.5,
  initial = { opacity: 0, y: 20 },
  animate = { opacity: 1, y: 0 },
  transition,
  ...props 
}) => {
  return (
    <motion.div
      initial={initial}
      animate={animate}
      transition={transition || { duration, delay, ease: "easeOut" }}
      {...props}
    >
      {children}
    </motion.div>
  );
};
